import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { RootState } from "../store/store";

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    timeout: 1000 * 120, // 30 seconds timeout
    baseUrl: process.env.REACT_APP_API_URL || "http://localhost:8080/api",
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState;
      const token = state.auth.token;

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      headers.set("content-type", "application/json");
      return headers;
    },
  }),
  tagTypes: [
    "Customer",
    "Lead",
    "LeadStats",
    "LandingPage",
    "LandingPageStats",
    "UIBlock",
    "Template",
    "Analytics",
  ],
  endpoints: () => ({}),
});
